class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Only enable hover behavior on desktop (min-width: 990px)
    if (window.innerWidth >= 990) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          this.mainDetailsToggle.setAttribute('open', '');
        }
      });

      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 990) {
          this.close();
        }
      });
    }

    // Handle window resize to toggle hover behavior based on screen size
    window.addEventListener('resize', () => {
      if (window.innerWidth < 990) {
        // Remove hover listeners on mobile
        this.mainDetailsToggle.removeAttribute('open');
      }
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.unifiedMegaMenu = this.findUnifiedMegaMenu();
    
    // Check if this is a unified mega menu trigger (menu item)
    const isMegaMenuTrigger = this.mainDetailsToggle && this.mainDetailsToggle.classList.contains('unified-mega-menu');
    
    // Setup hover handlers for unified mega menu on desktop
    if (isMegaMenuTrigger && window.innerWidth >= 990) {
      // When hovering over summary (menu item)
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          this.showUnifiedMenu();
        }
      });

      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 990) {
          this.hideUnifiedMenuWithDelay();
        }
      });

      // When hovering over the mega menu content itself
      if (this.unifiedMegaMenu) {
        this.unifiedMegaMenu.addEventListener('mouseenter', this.cancelHideTimer.bind(this));
        this.unifiedMegaMenu.addEventListener('mouseleave', this.hideUnifiedMenuWithDelay.bind(this));
      }
    }
  }

  findUnifiedMegaMenu() {
    // Find the unified mega menu in the document
    return document.querySelector('.unified-mega-menu-content');
  }

  showUnifiedMenu() {
    if (window.innerWidth < 990) return;
    
    if (this.unifiedMegaMenu) {
      this.unifiedMegaMenu.classList.add('visible');
      this.cancelHideTimer();
    }
  }

  hideUnifiedMenuWithDelay() {
    if (window.innerWidth < 990) return;
    
    this.hideTimer = setTimeout(() => {
      this.hideUnifiedMenu();
    }, 150);
  }

  cancelHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  hideUnifiedMenu() {
    if (this.unifiedMegaMenu) {
      // Check if any mega menu is still open/hovered
      const allMegaMenus = document.querySelectorAll('details.unified-mega-menu');
      const anyOpen = Array.from(allMegaMenus).some(menu => menu.hasAttribute('open'));
      const anyHovered = Array.from(allMegaMenus).some(menu => menu.matches(':hover'));
      
      if (!anyOpen && !anyHovered && !this.unifiedMegaMenu.matches(':hover')) {
        this.unifiedMegaMenu.classList.remove('visible');
      }
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
